import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { fetchDashboardEnrichedData } from '@/hooks/queries/useDashboardEnrichedQuery';

/**
 * Hook to handle all prefetching logic for company director/project supervisor roles.
 * Extracted from CompanyLayout for cleaner architecture.
 */
export function useCompanyPrefetch() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  // Prefetch dashboard data when user is authenticated
  useEffect(() => {
    if (!user?.company_id || !user?.id || !user?.role) return;

    queryClient.prefetchQuery({
      queryKey: ['dashboard-enriched', user.company_id, user.id, user.role, 'mois'],
      queryFn: () => fetchDashboardEnrichedData(user.company_id!, user.id, user.role!, 'mois'),
      staleTime: 1000 * 60 * 5, // 5 minutes
    });
  }, [user?.company_id, user?.id, user?.role, queryClient]);
}
